/* Accordéons */
$('.handheld-header__nav-wrapper .handheld-header__nav > .menu-item-has-children > a').click(function(e) {
    e.preventDefault();
    var $this = $(this);
    var $parent = $this.parent('.menu-item');
    var $openedBoxes = $('.menu-item.active');

    if($parent.length) {
      $('.accordion__content').removeClass('active');

      if($openedBoxes.length) {
        $openedBoxes.each(function(index, box) {
          if(box === $parent[0]) {
            $openedBoxes.splice(index, 1);
          }
        });
        if($openedBoxes.length) {
          $openedBoxes.removeClass('active');
        }
      }
      $parent.toggleClass('active');
    }
});

$('.menu-toggler').click(function() {
    $(this).parents('.site-header').toggleClass('handheld-menu--opened');
    $(this).toggleClass('menu-toggler--opened');
    $('.handheld-header__nav-wrapper').toggleClass('menu--opened');
})
